if (typeof Zmena_Uzivatele === 'undefined') {

    var Zmena_Uzivatele = {

        init: function () {

            var tlacitko = $('#tlacitko-hromadna-zmena-uzivatele');
            if (!tlacitko.length) {
                return;
            }

            tlacitko
                .off('click')
                .on('click', function (e) {
                    e.preventDefault();

                    var grid = $('#grid_section_i103');
                    var rows = $(grid).jqGrid('getGridParam', 'selarrrow');
                    if (!rows.length) {
                        Lemo_Alert.addInfo('Pro změnu uživatele označte alespoň jednu žádost', 'zmenaUzivateleInfo');
                        return;
                    }

                    var ids = [];
                    $.each(rows, function (i, id) {
                        ids.push(id);
                    });

                    $.ajax({
                        type: 'post',
                        url: '/plugin/PluginZadost/zmenaUzivateleFormularAjax',
                        dataType: 'json',
                        data: {'ids': ids},
                        global: false,
                        beforeSend: function () {
                            Lemo_Alert.closeAll();
                            Lemo_Alert.addInfo('Načítám formulář ...', 'zmenaUzivateleFormular');
                        },
                        complete: function () {
                            Lemo_Alert.closeById('zmenaUzivateleFormular');
                        },
                        success: function (data) {
                            Lemo_Alert.addMany(data.messages);
                            if (
                                false === data['status']
                                || !data.hasOwnProperty('html')
                                || !data['html'].length
                            ) {
                                return;
                            }

                            // modal
                            Lemo_Modal.setTitle('Hromadná změna uživatele žádostí');
                            Lemo_Modal.setContent(data.html);
                            // submit button
                            Lemo_Modal.addButton('continue', 'Pokračovat', 'btn btn-primary', function (e) {
                                e.preventDefault();

                                var grid = $('#grid_section_i103');
                                var rows = $(grid).jqGrid('getGridParam', 'selarrrow');
                                if (!rows.length) {
                                    Lemo_Alert.addDanger('Nejsou označeny žádosti pro změnu uživatele', 'zmenaUzivateleError');
                                    return;
                                }

                                var uzivatel = $('#modal-uzivatel');
                                if (!uzivatel.length || !uzivatel.val()) {
                                    Lemo_Alert.addDanger('Nebyl vybrán uživatel', 'zmenaUzivateleError');
                                    return;
                                }

                                var idsSelected = [];
                                $.each(rows, function (i, id) {
                                    idsSelected.push(id);
                                });

                                $.ajax({
                                    type: 'post',
                                    url: '/plugin/PluginZadost/zmenaUzivateleAjax',
                                    dataType: 'json',
                                    data: {'rows': idsSelected, 'uzivatelId': uzivatel.val()},
                                    global: true,
                                    beforeSend: function () {
                                        Lemo_Alert.closeAll();
                                    },
                                    success: function (data) {
                                        if (data.hasOwnProperty('messages')) {
                                            Lemo_Alert.addMany(data.messages);
                                        }
                                        grid.trigger('reloadGrid');
                                        Lemo_Modal.close();
                                    }
                                });

                            });
                            Lemo_Modal.addButton('cancel', 'Zrušit', 'btn btn-default', function () {
                                Lemo_Alert.closeAll();
                                Lemo_Modal.close();
                            });
                            Lemo_Modal.build();

                            Zmena_Uzivatele.initAutocomplete();
                        }
                    });
                });
        },

        // --- ZMENA UZIVATELE AUTOCOMPLETE ---
        initAutocomplete: function () {

            var uzivatel = $('#modal-uzivatel-autocomplete');
            if (!uzivatel.length) {
                Lemo_Modal.close();
                Lemo_Alert.addDanger('Nepodařilo se inicializovat formulář', 'zmenaUzivateleFormularError');
                return;
            }

            uzivatel.autocomplete({
                autofocus: true,
                minLength: 0,
                global: false,
                delay: 250,
                source: function (request, response) {
                    $.ajax({
                        url: '/plugin/PluginZadost/zmenaUzivateleAutocomplete',
                        dataType: 'json',
                        type: 'post',
                        data: {'uzivatel': uzivatel.val()},
                        success: function (r) {

                            var buttonSubmit = $('#dialogButtons').find('.btn-primary');
                            buttonSubmit.attr('disabled', true).prop('disabled', true);
                            var modalUzivatel = $('#modal-uzivatel');
                            modalUzivatel.val('');

                            if (r.hasOwnProperty('data')) {
                                if (!r.data.length) {
                                    Lemo_Alert.addDanger('Uživatel nenalezen', 'autocomplete');
                                }
                                response(r.data);
                            }
                        }
                    });
                },
                select: function (e, ui) {
                    e.preventDefault();
                    Lemo_Alert.closeById('autocomplete');
                    var modalUzivatel = $('#modal-uzivatel');
                    var buttonSubmit = $('#dialogButtons').find('.btn-primary');

                    if (ui.item !== null) {
                        $(this).val(ui.item.label);
                        modalUzivatel.val(ui.item.id);
                        buttonSubmit.attr('disabled', false).prop('disabled', false);
                    }
                }
            });
        }
    };
}

$(document)
    .ready(function () {
        Zmena_Uzivatele.init();
    });